import { render, staticRenderFns } from "./dialog-consent-etax.vue?vue&type=template&id=6bbd26b6&"
import script from "./dialog-consent-etax.vue?vue&type=script&lang=js&"
export * from "./dialog-consent-etax.vue?vue&type=script&lang=js&"
import style0 from "./dialog-consent-etax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports